import React from 'react';

export default function Logo({ className = "", light = false }) {
  const primaryColor = light ? "text-white" : "text-[#0e227b]";
  const secondaryColor = light ? "text-slate-400" : "text-slate-300";
  const subtextColor = light ? "text-slate-300" : "text-slate-600";

  return (
    <div className={`flex items-center select-none ${className}`}>
      {/* Text Brand Container with a stable width to ensure perfect block alignment */}
      <div className="flex flex-col justify-center w-32 sm:w-36 md:w-40">
        {/* RAVN'S filling the entire line */}
        <div className={`font-black font-sans ${primaryColor} leading-none flex justify-between w-full text-lg sm:text-xl md:text-2xl tracking-normal`}>
          <span>R</span>
          <span>A</span>
          <span>V</span>
          <span>N</span>
          <span>'</span>
          <span>S</span>
        </div>
        
        {/* Red horizontal line between RAVN'S and vinduespolering */}
        <div className="h-[1.5px] w-full bg-red-600 my-0.5 rounded-full" />
        
        {/* vinduespolering filling the line below */}
        <div className={`font-bold uppercase font-sans ${subtextColor} leading-none flex justify-between w-full text-[7px] sm:text-[8.5px] md:text-[9.5px] tracking-normal`}>
          <span>V</span>
          <span>I</span>
          <span>N</span>
          <span>D</span>
          <span>U</span>
          <span>E</span>
          <span>S</span>
          <span>P</span>
          <span>O</span>
          <span>L</span>
          <span>E</span>
          <span>R</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
        </div>
      </div>
    </div>
  );
}
